module.exports = __webpack_public_path__ + "static/media/theBoatImg.2263f7d8.jpg";